import { styled, css } from '../../../../../modules';
import { keyframes } from 'styled-components';

const divider = '#E3E6EB';
const questionColor = '#1A1D24';
const answerColor = '#5A6478';
const fadeIn = keyframes`
    from { opacity: 0; }
    to   { opacity: 1; }
`;

const fadeOut = keyframes`
    from { opacity: 1; }
    to   { opacity: 0; }
`;

const slideUp = keyframes`
    from { transform: translateY(100%); }
    to   { transform: translateY(0); }
`;

const slideDown = keyframes`
    from { transform: translateY(0); }
    to   { transform: translateY(100%); }
`;
export const Toggle = styled.button<{ $color: string }>`
    width: 100%;
    padding: 16px 20px;
    border: 1px solid ${({ $color }) => $color};
    border-radius: 8px;
    font-size: 16px;
    font-weight: 600;
    font-family: inherit;
    color: ${questionColor};
    background-color: transparent;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
`;

export const ModalOverlay = styled.div<{ $closing?: boolean }>`
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, 0.45);
    display: flex;
    align-items: flex-end;
    justify-content: center;
    z-index: 100;
    ${({ $closing }) =>
        $closing
            ? css`animation: ${fadeOut} 0.3s ease forwards;`
            : css`animation: ${fadeIn} 0.3s ease forwards;`}
`;
export const ModalSheet = styled.div<{
    $closing?: boolean;
    $drag?: number | null;
    $isDragging?: boolean;
}>`
    background: #ffffff;
    border-radius: 20px 20px 0 0;
    padding: 28px 24px 36px;
    width: 100%;
    max-width: calc(100vh * 3 / 4);
    max-height: 80vh;
    overflow-y: ${({ $isDragging }) => ($isDragging ? 'hidden' : 'auto')};
    overscroll-behavior: contain;
    display: flex;
    flex-direction: column;
    gap: 16px;
    ${({ $closing, $drag, $isDragging }) =>
        $drag !== null && $drag !== undefined
            ? css`
                  animation: none;
                  transform: translateY(${$drag}px);
                  transition: ${$isDragging ? 'none' : 'transform 0.3s ease'};
              `
            : $closing
              ? css`animation: ${slideDown} 0.3s ease forwards;`
              : css`animation: ${slideUp} 0.3s ease forwards;`}
`;

export const SheetHandle = styled.div`
    touch-action: none;
    width: 40px;
    height: 4px;
    border-radius: 2px;
    background-color: #ddd;
    align-self: center;
    margin-bottom: 4px;
    flex-shrink: 0;
`;

export const ModalTitle = styled.h2`
    font-size: 20px;
    font-weight: 700;
    color: ${questionColor};
    margin: 0;
`;

export const List = styled.div`
    display: flex;
    flex-direction: column;
`;

export const Item = styled.div`
    border-top: 1px solid ${divider};

    &:last-of-type {
        border-bottom: 1px solid ${divider};
    }
`;

export const ItemHeader = styled.button`
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    padding: 18px 0;
    border: none;
    background: transparent;
    text-align: left;
    cursor: pointer;
    font-family: inherit;
`;

export const Question = styled.span`
    font-size: 15px;
    line-height: 1.4;
    color: ${questionColor};
    text-wrap: pretty;
`;

export const Sign = styled.span`
    font-size: 22px;
    font-weight: 300;
    line-height: 1;
    color: ${questionColor};
    flex: none;
    padding-right: 4px;
`;

export const AnswerWrapper = styled.div<{ $open: boolean }>`
    display: grid;
    grid-template-rows: ${({ $open }) => ($open ? '1fr' : '0fr')};
    transition: grid-template-rows 0.3s ease;

    > .inner {
        overflow: hidden;
    }
`;

export const Answer = styled.p`
    font-size: 14px;
    line-height: 1.5;
    color: ${answerColor};
    margin: 0;
    padding: 0 0 18px;
    text-wrap: pretty;
`;
